export default function Title() {
  return <div className="text-3xl md:text-4xl text-white font-bold">EMERGENCY MANAGEMENT</div>;
}
